let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>      
    <actionType>add|update, 必填</actionType>
    <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
    <ownerCode>货主编码 string (50), 必填</ownerCode>
    <supplierCode>供应商编码, string (50)</supplierCode>
    <supplierName>供应商名称, string (200)</supplierName>
    <item>
        <itemCode>商品编码, string (50), 必填</itemCode>
        <itemId>仓储系统商品编码, string (50), 条件必填, 条件为商品同步接口更新时, 入参itemId不为空</itemId>
        <itemName>商品名称, string (200), 必填</itemName>
        <shortName>商品简称, string (200)</shortName>
        <englishName>商品英文名称, string (200)</englishName>
        <isValid>是否有效, boolean, Y=有效, N=无效. 默认Y, 为空时取默认值</isValid>
        <barCode>条形码, string (250), 可多个（最多五个, 单个条码长度50), 用分号（;）隔开, 必填</barCode>
        <title>商品标题, string (200)</title>
        <brandCode>品牌代码,  string (50)</brandCode>
        <brandName>品牌名称,  string (50)</brandName>
        <skuProperty>商品属性, string (200)，例如：红色, XXL</skuProperty>
        <length>长, double (18, 2)</length>
        <width>宽, double (18, 2)</width>
        <height>高, double (18, 2)</height>
        <volume>体积, double (18, 3)</volume>
        <grossWeight>毛重, double (18, 3)</grossWeight>
        <netWeight>净重, double (18, 3)</netWeight>
        <goodsCode>货号, string (50)</goodsCode>
        <color>颜色, string (50)</color>
        <year>年份, string (20)</year>
        <purchasePrice>价格, string (20)</purchasePrice>
        <size>尺寸, string (50)</size>
        <style>款式, string (50)</style>
        <categoryId>商品类别ID, string (50)</categoryId>
        <categoryName>商品类别名称, string (200) 必填</categoryName>
        <categoryName1>商品类别1, string (200)</categoryName1>
        <categoryName2>商品类别2, string (200)</categoryName2>
        <itemType>商品类型, string (10), 例如: ZC=正常商品, FX=分销商品, ZH=组合商品, ZP=赠品, BC=包材, HC=耗材, FL=辅料, XN=虚拟品, FS=附属品, CC=残次品, OTHER=其它(只传英文编码), 必填</itemType>
        <stockUnit>单位, string (50)，例如：个、瓶、支</stockUnit>
        <shelfLife>保质期天数, double (18, 3)</shelfLife>
        <packCode>默认包装代码, string (50)</packCode>
        <multiPackCodes>多包装代码, string (1000), 以英文逗号隔开, 例如: code1,code2,code3</multiPackCodes>
        <splitUom>订单拆分单位, string (50), EA=主单位, IP=内包装, CS=箱, PL=托盘</splitUom>
        <createTime>创建时间, string (19), YYYY-MM-DD HH:MM:SS</createTime>
        <updateTime>更新时间, string (19), YYYY-MM-DD HH:MM:SS</updateTime>
    </item>
    <extendProps>
        <key1>自定义字段1 (50)</key1>
        <key2>自定义字段2 (50)</key2>
        <key3>自定义字段3 (50)</key3>
        <key4>自定义字段4 (50)</key4>
        <key5>自定义字段5 (50)</key5>
    </extendProps>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
    <itemId>仓储系统商品Id, string (50),条件必填, 当这个字段不为空的时候, 所有erp传输的时候碰到itemId必传</itemId>
</response>
`

export default { xmlRequest, xmlResponse }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.singleitem.synchronize.js